import './CoursesSettings.scss';

export default function CoursesSettings({ userData, userSubscriptions }) {
  return (
    <div className="coursesSettings">
      <h3 className="coursesSettings-title">Factuur</h3>
      <div className="coursesSettings-insurance-name">{userData.insurer}</div>

      <ul className="coursesSettings-invoice-list">
        {userSubscriptions.map((item) => (
          <li className="coursesSettings-invoice-list-item" key={item.xuid}>
            <span className="coursesSettings-invoice-list-item-name">
              {item.type.split(':')[1]}
            </span>
            <a
              download
              href={item.getInvoicePdfUrl}
              className="coursesSettings-invoice-list-item-btn"
            >
              Downloaden
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
